<br>
<div style="width:95%">
  <span>
    <button class="btn btn border" (click)="save()">Spara</button>
    <button class="btn btn border" style="margin-left:20px;" (click)="close()">Avbryt</button>
  </span>
  <br><br>
  <br>
  <hr>
  <form [formGroup]="form">
    <div class="row">
      <div class="form-group col-md-3">
        <label for="startDate">
          Datum från
        </label>
        <input type="text" class="form-control form-control-sm" id="startDate" formControlName="startDate">
      </div>
      <div class="form-group col-md-3">
        <label for="endDate">
          Datum till
        </label>
        <input type="text" class="form-control form-control-sm" id="endDate" formControlName="endDate">
      </div>
      <div class="form-group col-md-2">
        <label for="payPercentage">
          Procent
        </label>
        <input type="text" class="form-control form-control-sm" id="payPercentage" formControlName="payPercentage">
      </div>
    </div>
  </form>
</div>
